import api from "../../../services/service_pos";
// import Swal from 'sweetalert2'

export default {
  props: ["host"],
  data() {
    return {
      amount: 0,
      description: "",
      header: {
        headers: {
          "Access-Token": sessionStorage.token
        }
      },
      hostshift: ""
    };
  },
  created() {
    this.hostshift = JSON.parse(sessionStorage.hostshift);
  },
  methods: {
    checkAmount() {
      if (this.amount === "") {
        this.amount = 0;
      }
    },
    openShift() {
      if (this.amount > 0) {
        this.$store.commit("Loading");
        var obj = {
          host_code: this.host.host_code,
          change_begin: parseInt(this.amount),
          my_description: this.description
        };
        api.openShift(
          this.REST_URL,
          obj,
          this.header,
          async result => {
            if (result.response === "success") {
              this.$store.commit("clearOrderPayment");
              $("#ShiftModal").modal("hide");
              $("body").on("hidden.bs.modal", ".modal", function() {
                $(this).removeData("bs.modal");
              });
              this.openCashBox(this.host);
              this.getListHostDetail(this.host, () => {
                this.printOpenSlip(result.data, () => {
                  window.location.reload();
                });
              });
            } else {
              this.$notification["warning"]({
                message: "เปิดการขายไม่ได้",
                description: result.message
              });
            }
            this.$store.commit("Loading");
            $("body").on("hidden.bs.modal", ".modal", function() {
              $(this).removeData("bs.modal");
            });
          },
          error => {
            alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
            this.$store.commit("Loading");
          }
        );
      } else {
        this.alert_msg(
          "warning",
          "เปิดกะการขาย",
          "ยอดปิดกะ ต้องมีค่ามากกว่า 0"
        );
      }
    },
    printOpenSlip(shift, onDone) {
      this.$store.commit("Loading");
      let playload = {
        shift_id: parseFloat(shift.id),
        host_code: shift.host_code,
        printer_port: this.hostshift.printer_port
      };
      api.changeSlip(
        this.REST_URL,
        {},
        playload,
        result => {
          if (result.response === "success") {
            this.$notification["success"]({
              message: "พิมพ์ใบเปิดกะสำเร็จ",
              description: result.message
            });
          } else {
            this.$notification["warning"]({
              message: "พิมพ์ใบเปิดกะไม่ได้ กรุณาลองใหม่",
              description: result.message
            });
          }
          this.$store.commit("Loading");
          if (typeof onDone === "function") {
            onDone();
          }
        },
        error => {
          alert("ไม่สามารถเข้าถึงข้อมูล " + JSON.stringify(error));
          this.$store.commit("Loading");
          if (typeof onDone === "function") {
            onDone();
          }
        }
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/pos/shiftopenmodal.js